import { useState } from "react";

import { useFormikContext } from "formik";

import { useCurrenciesQuery } from "@sso/apis/currency";
import { FormikTextInput } from "@sso/components/Formik";
import FormikTypeahead, { AutoCompleteOption } from "@sso/components/Formik/FormikTypeahead";
import { BillingAddressSignUpKeys, CountryKeys, OrganisationSignUpKeys } from "@sso/constant";
import { Country } from "@sso/types";

import CountryTypeahead from "./CountryTypeahead";

export const OrganisationForm = () => {
  const { setFieldValue } = useFormikContext();
  const [currencySearchTerm, setCurrencySearchTerm] = useState<string>("");

  const handleCountryChange = (country: Country) => {
    setFieldValue(`${OrganisationSignUpKeys.ADDRESS}.${BillingAddressSignUpKeys.COUNTRY}`, country);
    setFieldValue(`${OrganisationSignUpKeys.PHONE}`, country[CountryKeys.CALLING_CODE]);
    setFieldValue(`${OrganisationSignUpKeys.ORGANISATION_TRANSACTION_CURRENCY_CODE}`, country.defaultCurrencyCode);
  };

  const handleCountryClear = () => {
    setFieldValue(`${OrganisationSignUpKeys.ADDRESS}.${BillingAddressSignUpKeys.COUNTRY}`, null);
    setFieldValue(`${OrganisationSignUpKeys.PHONE}`, "");
    setFieldValue(`${OrganisationSignUpKeys.ORGANISATION_TRANSACTION_CURRENCY_CODE}`, "");
  };

  const { data: currencies, isLoading } = useCurrenciesQuery();

  const currencyOptions =
    (currencies?.map(x => ({
      key: x.code,
      value: x.code,
      label: `${x.symbol ?? ""} ${x.name} (${x.code})`,
    })) as AutoCompleteOption[]) || [];

  const onCurrencyClear = () => {
    setCurrencySearchTerm("");
  };

  return (
    <>
      <FormikTextInput name={OrganisationSignUpKeys.NAME} label="Organisation Name" />
      <FormikTextInput name={OrganisationSignUpKeys.BILLING_EMAIL} label="Billing Email" />
      <FormikTextInput
        name={`${OrganisationSignUpKeys.ADDRESS}.${BillingAddressSignUpKeys.FIRST_LINE}`}
        label="Address First Line"
      />
      <FormikTextInput
        name={`${OrganisationSignUpKeys.ADDRESS}.${BillingAddressSignUpKeys.SECOND_LINE}`}
        label="Address Second Line"
      />
      <FormikTextInput name={`${OrganisationSignUpKeys.ADDRESS}.${BillingAddressSignUpKeys.CITY}`} label="City" />
      <FormikTextInput name={`${OrganisationSignUpKeys.ADDRESS}.${BillingAddressSignUpKeys.STATE}`} label="State" />
      <FormikTextInput
        name={`${OrganisationSignUpKeys.ADDRESS}.${BillingAddressSignUpKeys.POSTCODE}`}
        label="Postcode"
      />
      <CountryTypeahead
        name={`${OrganisationSignUpKeys.ADDRESS}.${BillingAddressSignUpKeys.COUNTRY_ID}`}
        clear={handleCountryClear}
        handleChange={handleCountryChange}
      />
      <FormikTypeahead
        disabled={isLoading}
        items={currencyOptions.filter(x => x.label.toLowerCase().includes(currencySearchTerm.toLowerCase()))}
        label="Currency"
        onSearch={(term: string) => setCurrencySearchTerm(term)}
        clear={() => onCurrencyClear()}
        name={OrganisationSignUpKeys.ORGANISATION_TRANSACTION_CURRENCY_CODE}
      />
      <FormikTextInput name={OrganisationSignUpKeys.PHONE} label="Phone" />
      <FormikTextInput name={OrganisationSignUpKeys.VAT_NUMBER} label="VAT Number" />
    </>
  );
};
